var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var FlexFourth = function () {
	this.$isContainer = $( document.getElementById( 'is-container' ) );
	this.$scrollLoader = $( document.getElementById( 'scroll-loader' ) );
	this.page = 1;
};

FlexFourth.prototype.init = function () {

	var self = this;

	if ( 'undefined' === typeof self.$isContainer ) {
		return;
	}

	$( '.text-tile .inner' ).bigtext( {
		childSelector: 'h6, h4',
		maxfontsize: 200,
	} );

	self.$scrollLoader.click( function ( e ) {

		e.preventDefault();

		var productCat = $( this ).data( 'product-cat' );

		var data = {
			action: 'big_ajax_product_loop',
			ajax_nonce: big_ajax.ajax_nonce,
			product_cat: productCat,
			page: self.page++
		};

		$( this ).addClass( 'loading' );

		$.post( big_ajax.url, data, function ( response ) {

			if ( response.success ) {

				self.$isContainer.append( response.data.markup );

				if ( data.page === response.data.max_pages ) {
					self.$scrollLoader.hide();
				} else {
					self.$scrollLoader.removeClass( 'loading' );
				}
			} else {
				console.log( response );
			}
		} ).fail( function ( xhr, textStatus, e ) {
			console.log( xhr.responseText );
		} );
	} );
};

module.exports = new FlexFourth();
